import styled from 'styled-components';
import LightButton from '~/editor/buttons/LightButton';

const SmallButton = styled(LightButton)`
  padding: 5px 10px;
  font-size: 12px;
`;

export default SmallButton;
